import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'periodSalary',
})
export class PeriodSalaryPipe implements PipeTransform {
  transform(hourlySalary: number, hours: string): number {
    if (!hours || !hours.includes(':')) {
      console.warn(`Invalid hours format: ${hours}. Expected format "HH:mm".`);
      return 0;
    }
    const [hoursPart, minutesPart] = hours.split(':').map(Number);
    const totalHours = hoursPart + minutesPart / 60;
    const roundedTotalHours = Math.round(totalHours * 100) / 100;
    const periodSalary = hourlySalary * roundedTotalHours;
    return Math.round(periodSalary * 100) / 100; // Round to 2 decimal places
  }
}
